import { useSyncExternalStore } from 'react';

import {
  isStreamAvailable,
  subscribeStreamAvailability,
} from '@/viewmodel/features/etlSource/state/streamAvailability';

function isConfiguredEnabled(): boolean {
  const override = import.meta.env['VITE_LIVE_UPDATES'];

  if (override !== undefined) return override !== 'false' && override !== '0';

  return true;
}

export function useLiveUpdatesEnabled(): boolean {
  const available = useSyncExternalStore(
    subscribeStreamAvailability,
    isStreamAvailable,
    isStreamAvailable,
  );

  return isConfiguredEnabled() && available;
}
